import { render, staticRenderFns } from "./SubPageRoutes.vue?vue&type=template&id=d54de394&scoped=true&"
import script from "./SubPageRoutes.vue?vue&type=script&lang=js&"
export * from "./SubPageRoutes.vue?vue&type=script&lang=js&"
import style0 from "./SubPageRoutes.vue?vue&type=style&index=0&id=d54de394&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54de394",
  null
  
)

export default component.exports